import api from "./api.js";

export default class BaseInfoApi {
  static async getInfo() {
    return await api.get(`api/base-info`);
  }

  static async visit() {
    return await api.post(`api/visit`);
  }
}
